export default __webpack_public_path__ + "static/media/math.2bbe7769.mp4";